import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation, NavLink } from "react-router-dom";
import logo from "../../images/logo/TigrisPayLogo.png";
import MobileMenu from "../MobileMenu/MobileMenu";
import { FaChevronDown } from "react-icons/fa";
import "./CountrySubmenu.css";

const Header = (props) => {
  const [mobailActive, setMobailState] = useState(false);
  const [isSticky, setSticky] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [showSubmenu, setShowSubmenu] = useState(false);
  const [showCookiesConsent, setShowCookiesConsent] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Country data
  const countries = [
    { name: "India", code: "INR", symbol: "₹", path: "/send-money-to-india", flag: "images/flags/inr.png" },
    { name: "Pakistan", code: "PKR", symbol: "Rs", path: "/send-money-to-pakistan", flag: "images/flags/pkr.png" },
    { name: "Bangladesh", code: "BDT", symbol: "৳", path: "/send-money-to-bangladesh", flag: "images/flags/bdt.png" },
    { name: "Nepal", code: "NPR", symbol: "रू", path: "/send-money-to-nepal", flag: "images/flags/npr.png" },
    // { name: "Nigeria", code: "NGN", symbol: "₦", path: "/send-money-to-nigeria", flag: "images/flags/ngn.png" },
    { name: "Sri Lanka", code: "LKR", symbol: "රු", path: "/send-money-to-srilanka", flag: "images/flags/lkr.png" },
    // { name: "Malaysia", code: "MYR", symbol: "RM", path: "/send-money-to-malaysia", flag: "images/flags/myr.png" },
    // { name: "Philippines", code: "PHP", symbol: "₱", path: "/send-money-to-philipphins", flag: "images/flags/php.png" }
  ];

  // Determine current country based on URL
  const getCurrentCountry = () => {
    const currentPath = location.pathname;
    return countries.find(country => country.path === currentPath);
  };

  const currentCountry = getCurrentCountry();

  // Filter countries based on search query
  const filteredCountries = countries.filter(country =>
    country.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleDownloadClick = () => {
    navigate("/download");
    window.scrollTo(10, 0);
  };

  // Cookies consent functions
  const checkCookiesConsent = () => {
    const consent = localStorage.getItem('cookiesConsent');
    if (!consent) {
      setShowCookiesConsent(true);
    }
  };

  const acceptCookies = () => {
    localStorage.setItem('cookiesConsent', 'accepted');
    setShowCookiesConsent(false);
  };

  useEffect(() => {
    checkCookiesConsent();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      id="xb-header-area"
      className="header-area header-style-two header-transparent"
      style={{ backgroundColor: "transparent", boxShadow: "none", zIndex: "9999" }}
    >
      <div
        className={`xb-header stricky ${isSticky ? "stricked-menu stricky-fixed" : ""
          }`}
      >
        <div className="container">
          <div className="header__wrap ul_li_between">
            {/* ===== LOGO ===== */}
            <div className="header-logo">
              <Link onClick={ClickHandler} to="/">
                <img src={logo} style={{ maxWidth: "120px" }} alt="TigrisPay" />
              </Link>
            </div>

            {/* ===== MAIN MENU ===== */}
            <div className="main-menu__wrap ul_li navbar navbar-expand-xl">
              <nav className="main-menu collapse navbar-collapse">
                <ul>
                  <li className="menu-item-has-children"
                    onMouseEnter={() => setShowSubmenu(true)}
                    onMouseLeave={() => setShowSubmenu(false)}>
                    <Link onClick={ClickHandler} to="/">
                      {currentCountry ? (
                        <span className="current-country-display">

                          <img
                            src={currentCountry.flag}
                            alt={`${currentCountry.name} Flag`}
                            style={{ width: "25px", height: "25px", borderRadius: "50%", objectFit: "cover" }}
                          />
                          <span className="send-money-text">Send Money to</span>
                          <span className="current-country-name">{currentCountry.name}</span>
                        </span>
                      ) : (
                        <span>Send Money</span>
                      )}
                      <FaChevronDown
                        style={{ marginLeft: "6px", fontSize: "0.8em" }}
                      />
                    </Link>
                    <div
                      className="submenu country-submenu"
                      style={{
                        position: "absolute",
                        top: "100%",
                        right: 0,
                        width: "320px",
                        background: "rgba(255,255,255,0.95)",
                        backdropFilter: "blur(14px)",
                        borderRadius: "14px",
                        boxShadow: "0 20px 50px rgba(0,0,0,0.15)",
                        padding: "12px",
                        zIndex: 9999,
                      }}
                    >
                      {/* SEARCH */}
                      <div
                        className="country-search"
                        style={{
                          marginBottom: "12px",
                          padding: "8px 14px"
                        }}
                      >
                        <input
                          type="text"
                          placeholder="Search country..."
                          value={searchQuery}
                          onChange={handleSearchChange}
                          style={{
                            width: "100%",
                            height: "60px",
                            padding: "8px 14px",
                            borderRadius: "10px",
                            border: "1px solid #e5e7eb",
                            fontSize: "14px",
                            outline: "none",
                            boxShadow: "inset 0 1px 2px rgba(0,0,0,0.05)",
                          }}
                        />
                      </div>

                      {/* COUNTRY LIST */}
                      <div
                        className="country-list"
                        style={{
                          maxHeight: "280px",
                          overflowY: "auto",
                          paddingRight: "4px",
                        }}
                      >
                        {/* COUNTRY NOT FOUND */}
                        {filteredCountries.length === 0 && (
                          <div
                            style={{
                              padding: "24px 12px",
                              textAlign: "center",
                              color: "#6b7280",
                              fontSize: "14px",
                              fontWeight: 500,
                            }}
                          >
                            Country not found
                          </div>
                        )}

                        {filteredCountries.map((country, index) => (
                          <div
                            key={index}
                            className="country-item-container"
                            style={{
                              marginBottom: "6px",
                            }}
                          >
                            <Link
                              onClick={ClickHandler}
                              to={country.path}
                              style={{
                                textDecoration: "none",
                              }}
                            >
                              <div
                                className="country-item"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "12px",
                                  padding: "10px 12px",
                                  borderRadius: "10px",
                                  cursor: "pointer",
                                  transition: "all 0.25s ease",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.background = "#f3f4f6";
                                  e.currentTarget.style.transform = "translateX(4px)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.background = "transparent";
                                  e.currentTarget.style.transform = "translateX(0)";
                                }}
                              >
                                {/* FLAG */}
                                <div
                                  className="flag"
                                  style={{
                                    width: "34px",
                                    height: "34px",
                                    borderRadius: "50%",
                                    overflow: "hidden",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                    flexShrink: 0,
                                  }}
                                >
                                  <img
                                    src={country.flag}
                                    alt={`${country.name} Flag`}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                    }}
                                  />
                                </div>

                                {/* INFO */}
                                <div
                                  className="country-info"
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    lineHeight: "1.2",
                                  }}
                                >
                                  <span
                                    className="country-name"
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: 600,
                                      color: "#111827",
                                    }}
                                  >
                                    {country.name}
                                  </span>
                                  <span
                                    className="currency-code"
                                    style={{
                                      fontSize: "12px",
                                      color: "#6b7280",
                                    }}
                                  >
                                    {country.code} — {country.symbol}
                                  </span>
                                </div>
                              </div>
                            </Link>
                          </div>
                        ))}
                      </div>
                    </div>


                  </li>
                </ul>



                <ul>
                  <li>
                    <Link onClick={ClickHandler} to="/refer-and-earn">
                      Refer & Earn
                    </Link>
                  </li>
                </ul>

                <ul>
                  <li>
                    <Link onClick={ClickHandler} to="/help">
                      Help
                    </Link>
                  </li>
                </ul>

                <ul>
                  <li>
                    <Link onClick={ClickHandler} to="/contact-us">
                      Contact Us
                    </Link>
                  </li>
                </ul>
              </nav>

              {/* ===== DOWNLOAD BUTTON ===== */}
              <div className="header-contact d-none d-md-flex align-items-center">
                <button
                  onClick={handleDownloadClick}
                  className="thm-btn thm-btn--aso thm-btn--header-black download-btn"
                >
                  <span className="btn-text">Download App</span>
                  <span className="btn-icon">↓</span>
                </button>
              </div>

              {/* ===== MOBILE MENU ===== */}
              <div className="xb-header-wrap">
                <div
                  className={`xb-header-menu ${mobailActive ? "active" : ""}`}
                >
                  <div className="xb-header-menu-scroll lenis lenis-smooth">
                    <div
                      className="xb-menu-close xb-hide-xl xb-close"
                      onClick={() => setMobailState(!mobailActive)}
                    ></div>

                    {/* ===== MOBILE LOGO LEFT ALIGNED ===== */}
                    <div className="xb-logo-mobile xb-hide-xl mb-3 text-start ps-3">
                      <Link onClick={ClickHandler} to="/" rel="home">
                        <img
                          src={logo}
                          alt="TigrisPay Mobile Logo"
                          style={{ maxWidth: "120px" }}
                        />
                      </Link>
                    </div>

                    {/* MOBILE NAVIGATION */}
                    <nav className="xb-header-nav">
                      <MobileMenu />

                      {/* ===== MOBILE DOWNLOAD BUTTON ===== */}
                      <div className="mobile-auth-buttons d-xl-none mt-4 d-flex flex-row align-items-center gap-3">
                        <button
                          onClick={handleDownloadClick}
                          className="thm-btn thm-btn--aso w-100 text-center download-btn-mobile"
                        >
                          <span className="btn-text">Download App</span>
                          <span className="btn-icon">↓</span>
                        </button>
                      </div>
                    </nav>
                  </div>
                </div>
              </div>

              <div className="xb-header-menu-backdrop"></div>
            </div>

            {/* ===== MOBILE MENU BUTTON ===== */}
            <div className="header-bar-mobile side-menu d-xl-none">
              <button
                className="xb-nav-mobile"
                onClick={() => setMobailState(!mobailActive)}
              >
                <i className="far fa-bars" style={{ color: "black" }}></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ===== CUSTOM STYLES FOR DOWNLOAD BUTTON ===== */}
      <style>{`
        .download-btn {
          position: relative;
          overflow: hidden;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 8px;
        }        
        .download-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 15px rgba(0, 0, 0, 0.2);
        }
        
        .download-btn:active {
          transform: translateY(0);
        }
        
        .btn-text {
          transition: transform 0.3s ease;
        }
        
        .btn-icon {
          transition: transform 0.3s ease;
        }
        
        .download-btn:hover .btn-text {
          transform: translateX(-3px);
        }
        
        .download-btn:hover .btn-icon {
          transform: translateY(3px);
        }
        
        .download-btn-mobile {
          position: relative;
          overflow: hidden;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }
        
        .download-btn-mobile:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 15px rgba(0, 0, 0, 0.2);
        }
        
        /* Current country display styles */
        .current-country-display {
          display: flex;
          align-items: center;
          gap: 8px;
        }
        
        .send-money-text {
          font-weight: 500;
        }
        
        .current-country-flag {
          width: 20px;
          height: 20px;
          border-radius: 4px;
          object-fit: contain;
        }
        
        .current-country-name {
          font-weight: 600;
        }
      `}</style>

      {/* Cookies Consent Banner */}
      {showCookiesConsent && (
        <div className="cookies-consent-banner" style={{
          position: 'fixed',
          bottom: '20px',
          left: '20px',
          right: '20px',
          background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
          backdropFilter: 'blur(20px)',
          borderRadius: '16px',
          padding: '24px',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15), 0 8px 32px rgba(0, 0, 0, 0.08)',
          zIndex: '10000',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          maxWidth: '520px',
          margin: '0 auto',
          animation: 'slideUp 0.5s ease-out',
          transform: 'translateY(0)',
          transition: 'all 0.3s ease'
        }}>
          <div className="d-flex align-items-center justify-content-start gap-3 mb-3">
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '12px',
              background: 'linear-gradient(135deg, #ffcc29 0%, #ffd600 100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 4px 12px rgba(255, 204, 41, 0.3)'
            }}>
              <img
                src="../images/cookies.png"
                alt="cookies consent"
                style={{
                  width: '24px',
                  height: '24px',

                }}
              />
            </div>
            <div>
              <h5 style={{
                margin: 0,
                fontSize: '20px',
                fontWeight: '700',
                color: '#1e293b',
                background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                Cookies Consent
              </h5>
              <p style={{
                margin: '2px 0 0 0',
                fontSize: '12px',
                color: '#64748b',
                fontWeight: '500'
              }}>
                We value your privacy
              </p>
            </div>
          </div>

          <div className="content">
            <p style={{
              margin: '0 0 20px 0',
              fontSize: '14px',
              color: '#475569',
              lineHeight: '1.6',
              fontWeight: '400'
            }}>
              We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. By continuing to use our site, you consent to our use of cookies.
            </p>

            <div className="d-flex align-items-center gap-3">
              <button
                className="accept-btn"
                onClick={acceptCookies}
                style={{
                  background: 'linear-gradient(135deg, #ffcc29 0%, #ffd600 100%)',
                  border: 'none',
                  borderRadius: '10px',
                  padding: '12px 24px',
                  color: '#1e293b',
                  fontWeight: '600',
                  fontSize: '14px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 15px rgba(255, 204, 41, 0.3)',
                  minWidth: '120px'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 8px 25px rgba(255, 204, 41, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 15px rgba(255, 204, 41, 0.3)';
                }}
              >
                <span className='txt'>Accept All</span>
              </button>

              <NavLink
                to="/privacy-policy"
                className="privacy-link"
                style={{
                  textDecoration: 'none',
                  color: '#64748b',
                  fontWeight: '500',
                  fontSize: '14px',
                  transition: 'all 0.3s ease',
                  padding: '12px 20px',
                  borderRadius: '10px',
                  border: '2px solid #ffcc29',
                  background: 'transparent',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minWidth: '130px'
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#1e293b';
                  e.target.style.borderColor = '#ffd600';
                  e.target.style.backgroundColor = 'rgba(255, 204, 41, 0.1)';
                  e.target.style.transform = 'translateY(-1px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = '#64748b';
                  e.target.style.borderColor = '#ffcc29';
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                Privacy Policy
              </NavLink>
            </div>
          </div>
        </div>
      )}

      {/* Add CSS animation for slide up effect */}
      <style>{`
        @keyframes slideUp {
          from {
            transform: translateY(100px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        
        .cookies-consent-banner {
          animation-fill-mode: both;
        }
        
        .accept-btn:hover {
          background: linear-gradient(135deg, #ffd600 0%, #ffcc29 100%) !important;
        }
        
        .privacy-link:hover {
          text-decoration: none !important;
        }
      `}</style>
    </div>
  );
};

export default Header;